
import React from 'react'
import { withStyles, WithStyles, createStyles, Theme, StyleRules } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { CloseIcon } from '../../../Components/Icons/Icons'

// eslint-disable-next-line
const styles = (theme: Theme): StyleRules =>
  createStyles({
    dialogTitleText: {
      fontWeight: 600,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  })

interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string
  children: React.ReactNode
  onClose: () => void
}

export const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.dialogTitle} {...other}>
      <Typography variant="h6" className={classes.dialogTitleText}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon viewBox="0 0 16 16"/>
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})
